import React, { useState, useEffect } from 'react';

const REVIEWS = [
    { name: "Lavinia", location: "London England", tag: "Excellent ", text: "Learning with Francesca is a joy. She fits her teaching around your capabilities. She is very thorough extremely patient a lot of fun. Highly recommend." },
  { name: "Stan P.",         location: "Washington, DC",      tag: "A Miracle",          text: "I tried unsuccessfully for 12 years to learn Italian—apps and classes didn't work. In only two months, Francesca helped me dissolve my fear of making mistakes. She is a remarkably perceptive teacher. I am moving from the States to Rome and Francesca has given me the confidence I needed to keep speaking no matter what." },
  { name: "Nicholas K.",     location: "New York, NY",        tag: "Amazing Progress",   text: "Francesca is an amazing teacher! She's helped my Italian improve so much over the last few months. I couldn't recommend her more!" },
  { name: "Robert G.",       location: "New York, NY",        tag: "Tailored Coaching",  text: "Francesca is thoughtful, organized, and supportive. She quickly understands what I might need and adjusts lessons to accommodate. I couldn't recommend her more." },
  { name: "James",           location: "Georgetown, DC",      tag: "Customized Learning",text: "She works with me at my own pace and helps me learn by customizing the lessons to my learning style. She is patient and very passionate about teaching Italian." },
  { name: "Teresa",          location: "Soquel, CA",          tag: "Lifelong Goal",      text: "Francesca is amazing!!! It has been a lifelong goal to learn Italian. I tried in traditional classrooms but was unable to learn. Her lessons are wonderful, filled with visual examples and interactive homework. I know I will now be able to learn Italian." },
  { name: "Katrina & Sid",   location: "New York, NY",        tag: "Full Immersion",     text: "My spouse and I came to her knowing basic Italian. Having 1.5 hr lessons 3 times a week has made a huge difference. Because she is living in a different country than her native one, she really understands the struggles of learning a new language." },
  { name: "Pablo V.",        location: "San Francisco, CA",   tag: "Personalized Method",text: "I really appreciate all the progress I have done so far. She manages to create a personalized learning methodology that makes these lessons really pleasant. Highly recommended!" },
  { name: "Anthony K.",      location: "New York, NY",        tag: "The Best",           text: "She is the best!!! I promise you won't regret choosing Francesca. She is the nicest and the best teacher I have ever had." },
  { name: "Eva D.",          location: "Los Angeles, CA",     tag: "Excellent Material", text: "Francesca is very dedicated, patient, and exigent at the same time. She provides all the material which makes it much easier!" },
  { name: "Donna & Ed P.",   location: "Washington, DC",      tag: "Patient Support",    text: "Francesca has been such a great help and is very patient. She was recommended by a friend who is also very happy." },
  { name: "Pam G.",          location: "Enfield, CT",         tag: "Confidence",         text: "I never imagined that at my age I would be studying Italian! Francesca offers encouragement when I don't have the confidence in myself. I am so lucky to have found her." },
  { name: "Salvatore L.",    location: "Miami, FL",           tag: "Fluency",            text: "With her, I have made incredible strides toward becoming fluent in Italian. She quickly identified my learning style and has adapted the lessons accordingly." },
  { name: "James",           location: "San Diego, CA",       tag: "Quality Tuition",    text: "She makes lessons fun, interactive, and engaging. She modifies the lessons specifically to her students and doesn't just try to teach off some book like schools do." },
  { name: "Ffion",           location: "Cardiff, WALES",      tag: "Structured",         text: "Francesca's lessons are well prepared and well structured. She is always patient, good humoured and encouraging." },
  { name: "Dominick",        location: "Pittsburgh, PA",      tag: "Fast Results",       text: "A very friendly and patient tutor who has helped me to accelerate my Italian learning much more quickly than with group classes." },
  { name: "Sian",            location: "Cardiff, WALES",      tag: "Clear Guidance",     text: "Francesca gave me clear tuition in the grammatical aspects of Italian. I enjoyed all the lessons and homework. Grazie." },
  { name: "Nicholas M.",     location: "Washington, DC",      tag: "Online Resources",   text: "Francesca is a wonderful teacher who makes good use of online resources during our lessons. I would highly recommend her." },
  { name: "Latif",           location: "Doha, QATAR",         tag: "Fun Lessons",        text: "Really great, making such progress and fun to work with Francesca!" },
  { name: "Brian Z.",        location: "Milwaukee, WI",       tag: "Organized",          text: "Francesca is a wonderful Italian tutor! She is so organized and makes it easy to learn new material." },
  { name: "Tony",            location: "Seattle, WA",         tag: "Inspirational",      text: "I have zero background of Italian, but Francesca is able to help me overcome the difficulties and inspire me to learn more." },
  { name: "Mick",  location: "London, UK",          tag: "Precise",            text: "Francesca is a very patient tutor and very precise in her teaching." },
  { name: "Samantha",        location: "Atlanta, GA",         tag: "High Quality",       text: "If you're looking for a private tutor with excellent quality, you found her." },
  { name: "Heather K.",      location: "San Antonio, TX",     tag: "Clear Explanations", text: "The best Italian tutor I have ever found! She is very patient and explains everything very clear and easy to understand." },
  { name: "Giovanna",        location: "Brazil",              tag: "Cultural Passion",   text: "You can feel the passion she has for her culture/country, which makes it more exciting to learn the language." },
  { name: "Sean",            location: "Pittsburgh, PA",      tag: "Highly Recommend",   text: "I have had several classes with her and I am already learning a lot! She makes sure you are pronouncing words correctly. She gives out homework to practice and adjust her lessons for your learning." },
  { name: "Rosalba",         location: "Charlotte, NC",       tag: "Beginner Friendly",  text: "Great. Takes careful measures in helping you grasp a concept, patient, and fun." },
  { name: "Alice B.",        location: "Kampala, Uganda",     tag: "Pace Control",       text: "Her lessons are well planned and she goes at the perfect pace that allows you to absorb all the information presented." },
  { name: "Richard",         location: "London, UK",          tag: "Supportive",         text: "Francesca is a very supportive Italian teacher. It is great learning Italian with her." },
  { name: "Victoria",        location: "Zurigo, SWITZERLAND", tag: "Progress",           text: "Every lesson flies by so quickly and you want more. I have started my Italian journey with her and achieved great results." },
  { name: "Tracy S.",        location: "San Francisco, CA",   tag: "The Best",           text: "Pick her... she is the best." },
  { name: "Philippe H.",     location: "Paris, FRANCE",       tag: "Five Stars",         text: "Excellent instructor. Highly recommended for anyone looking to master the Italian language." },
  { name: "Lavinia", location: "London England", tag: "Excellent ", text: "Learning with Francesca is a joy. She fits her teaching around your capabilities. She is very thorough extremely patient a lot of fun. Highly recommend." },
];

const AUTOPLAY_INTERVAL = 8000;
const STARS = '★★★★★';

// Returns indices for [left, center, right] on desktop
const getTriple = (index) => {
  const prev = index === 0 ? REVIEWS.length - 1 : index - 1;
  const next = index === REVIEWS.length - 1 ? 0 : index + 1;
  return [prev, index, next];
};

// Visible dots — show up to 7 dots centered around current
const getVisibleDots = (current, total) => {
  const max   = 7;
  if (total <= max) return Array.from({ length: total }, (_, i) => i);
  const half  = Math.floor(max / 2);
  let start   = current - half;
  let end     = current + half;
  if (start < 0)          { start = 0; end = max - 1; }
  if (end >= total)        { end = total - 1; start = total - max; }
  return Array.from({ length: max }, (_, i) => start + i);
};

export const Reviews = ({ styles: externalStyles }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused,     setIsPaused]     = useState(false);
  const [isMobile,     setIsMobile]     = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleNext = () => setCurrentIndex(i => (i === REVIEWS.length - 1 ? 0 : i + 1));
  const handlePrev = () => setCurrentIndex(i => (i === 0 ? REVIEWS.length - 1 : i - 1));

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(handleNext, AUTOPLAY_INTERVAL);
    return () => clearInterval(interval);
  }, [isPaused]); // eslint-disable-line

  const [prevIdx, centerIdx, nextIdx] = getTriple(currentIndex);
  const visibleDots = getVisibleDots(currentIndex, REVIEWS.length);

  return (
    <section style={sectionStyle}>

      {/* Header */}
      <div style={headerStyle}>
        <p style={nudgeStyle}>WHAT STUDENTS SAY</p>
        <h2 style={titleStyle}>
  Success Stories{' '}
  <br />
  <span style={{ fontStyle: 'italic', color: TERRACOTTA }}>from Around the World</span>
</h2>
      </div>

      {/* Cards */}
      <div
        style={carouselWrapperStyle}
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        {/* Prev arrow */}
        <button style={arrowBtnStyle} onClick={handlePrev}>‹</button>

        <div style={{ ...cardsRowStyle, flexDirection: isMobile ? 'column' : 'row' }}>

          {/* Left card — desktop only */}
          {!isMobile && (
            <div style={sideCardStyle} onClick={handlePrev}>
              <div style={sideTagStyle}>{REVIEWS[prevIdx].tag}</div>
              <p style={sideTextStyle}>"{REVIEWS[prevIdx].text}"</p>
              <p style={sideAuthorStyle}>{REVIEWS[prevIdx].name}</p>
            </div>
          )}

          {/* Center card — featured */}
          <div style={centerCardStyle}>
            <div style={starsStyle}>{STARS}</div>
            <div style={centerTagStyle}>{REVIEWS[centerIdx].tag}</div>
            <p style={centerTextStyle}>"{REVIEWS[centerIdx].text}"</p>
            <div style={authorRowStyle}>
              <div style={avatarStyle}>{REVIEWS[centerIdx].name.charAt(0)}</div>
              <div>
                <p style={authorNameStyle}>{REVIEWS[centerIdx].name}</p>
                <p style={authorLocationStyle}>{REVIEWS[centerIdx].location}</p>
              </div>
            </div>
          </div>

          {/* Right card — desktop only */}
          {!isMobile && (
            <div style={sideCardStyle} onClick={handleNext}>
              <div style={sideTagStyle}>{REVIEWS[nextIdx].tag}</div>
              <p style={sideTextStyle}>"{REVIEWS[nextIdx].text}"</p>
              <p style={sideAuthorStyle}>{REVIEWS[nextIdx].name}</p>
            </div>
          )}

        </div>

        {/* Next arrow */}
        <button style={arrowBtnStyle} onClick={handleNext}>›</button>
      </div>

      {/* Dots */}
      <div style={dotsRowStyle}>
        {currentIndex > 3 && <span style={dotFadeStyle}>•</span>}
        {visibleDots.map(i => (
          <button
            key={i}
            onClick={() => setCurrentIndex(i)}
            style={{
              ...dotBtnStyle,
              backgroundColor: i === currentIndex ? TERRACOTTA : 'rgba(188,108,37,0.2)',
              transform: i === currentIndex ? 'scale(1.3)' : 'scale(1)',
            }}
          />
        ))}
        {currentIndex < REVIEWS.length - 4 && <span style={dotFadeStyle}>•</span>}
      </div>

      {/* Total count */}
      <p style={counterStyle}>{currentIndex + 1} of {REVIEWS.length}</p>

    </section>
  );
};

// ─── Styles ───────────────────────────────────────────────────────────────────
const TERRACOTTA = '#BC6C25';
const DEEP_MOSS  = '#283618';
const PAPER      = '#FCF9F2';

const sectionStyle = {
  backgroundColor: PAPER,
  padding: '100px 20px',
  overflow: 'hidden',
};

const headerStyle = {
  textAlign: 'center',
  marginBottom: '60px',
};

const nudgeStyle = {
  fontFamily: "'Montserrat', sans-serif",
  fontSize: '0.65rem',
  letterSpacing: '3px',
  color: TERRACOTTA,
  fontWeight: 700,
  marginBottom: '12px',
};

const titleStyle = {
  fontFamily: "'Cormorant Garamond', serif",
  fontSize: 'clamp(2rem, 5vw, 3rem)',
  fontWeight: 400,
  color: DEEP_MOSS,
  margin: '0 0 16px',
};

// Carousel
const carouselWrapperStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '16px',
  maxWidth: '1100px',
  margin: '0 auto',
};

const cardsRowStyle = {
  display: 'flex',
  alignItems: 'stretch',
  gap: '20px',
  flex: 1,
};

// Side cards
const sideCardStyle = {
  flex: 1,
  backgroundColor: '#fff',
  borderRadius: '16px',
  padding: '28px',
  opacity: 0.45,
  cursor: 'pointer',
  transition: 'opacity 0.3s ease',
  border: '1px solid rgba(188,108,37,0.08)',
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  overflow: 'hidden',
};

const sideTagStyle = {
  fontFamily: "'Montserrat', sans-serif",
  fontSize: '0.6rem',
  letterSpacing: '1.5px',
  textTransform: 'uppercase',
  color: TERRACOTTA,
  fontWeight: 700,
};

const sideTextStyle = {
  fontFamily: "'Cormorant Garamond', serif",
  fontSize: '1rem',
  fontStyle: 'italic',
  color: DEEP_MOSS,
  lineHeight: '1.5',
  display: '-webkit-box',
  WebkitLineClamp: 4,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  flex: 1,
};

const sideAuthorStyle = {
  fontFamily: "'Montserrat', sans-serif",
  fontSize: '0.7rem',
  color: '#999',
  marginTop: 'auto',
};

// Center card
const centerCardStyle = {
  flex: 1.4,
  backgroundColor: '#fff',
  borderRadius: '20px',
  padding: '40px',
  boxShadow: '0 20px 50px rgba(40,54,24,0.08)',
  border: `1px solid rgba(188,108,37,0.15)`,
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  position: 'relative',
  zIndex: 1,
};

const starsStyle = {
  color: TERRACOTTA,
  fontSize: '1rem',
  letterSpacing: '3px',
};

const centerTagStyle = {
  fontFamily: "'Cormorant Garamond', serif",
  fontSize: '1.5rem',
  fontStyle: 'italic',
  color: TERRACOTTA,
  fontWeight: 400,
};

const centerTextStyle = {
  fontFamily: "'Cormorant Garamond', serif",
  fontSize: 'clamp(1rem, 2vw, 1.15rem)',
  fontStyle: 'italic',
  color: DEEP_MOSS,
  lineHeight: '1.7',
  flex: 1,
};

const authorRowStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  marginTop: '8px',
  paddingTop: '16px',
  borderTop: '1px solid rgba(188,108,37,0.1)',
};

const avatarStyle = {
  width: '38px',
  height: '38px',
  borderRadius: '50%',
  backgroundColor: PAPER,
  border: `1px solid rgba(188,108,37,0.2)`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '0.9rem',
  fontWeight: 700,
  color: TERRACOTTA,
  fontFamily: "'Montserrat', sans-serif",
  flexShrink: 0,
};

const authorNameStyle = {
  fontFamily: "'Montserrat', sans-serif",
  fontSize: '0.8rem',
  fontWeight: 700,
  color: DEEP_MOSS,
  margin: 0,
};

const authorLocationStyle = {
  fontFamily: "'Montserrat', sans-serif",
  fontSize: '0.65rem',
  color: '#999',
  margin: '2px 0 0',
};

// Arrow buttons
const arrowBtnStyle = {
  background: 'none',
  border: `1px solid rgba(188,108,37,0.25)`,
  borderRadius: '50%',
  width: '44px',
  height: '44px',
  fontSize: '1.4rem',
  color: TERRACOTTA,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  transition: 'all 0.2s ease',
};

// Dots
const dotsRowStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '6px',
  marginTop: '36px',
};

const dotBtnStyle = {
  width: '7px',
  height: '7px',
  borderRadius: '50%',
  border: 'none',
  cursor: 'pointer',
  padding: 0,
  transition: 'all 0.3s ease',
};

const dotFadeStyle = {
  fontSize: '0.5rem',
  color: 'rgba(188,108,37,0.3)',
  lineHeight: 1,
};

const counterStyle = {
  textAlign: 'center',
  marginTop: '12px',
  fontSize: '0.65rem',
  color: '#bbb',
  fontFamily: "'Montserrat', sans-serif",
  letterSpacing: '1px',
};